// Locales

$(function() {
  'use strict';

  $('.js-locales-current').on('click', function(event) {
    event.preventDefault();

    $('.js-locales-items').toggleClass('is-active');
  });

});
